module.exports = __webpack_public_path__ + "img/4.6bc69781.jpg";